import * as R from 'ramda';
import useSWR, {SWRConfiguration, SWRResponse} from 'swr';
import {AxiosError} from 'axios';
import {fetcher, FetcherConfigEntityT} from './fetcher';
import {useAuth} from '../providers/auth/auth-provider';
import {NullableT} from '../definitions/common.definitions';

export function useGet<DataT, ParamsT = Object>(cfg: {
  key: NullableT<string>,
  config?: SWRConfiguration,
  params?: ParamsT,
  auth?: boolean,
  ver?: string,
}): SWRResponse<DataT> {
  const {
    token,
    clearToken,
  } = useAuth();
  const {
    key,
    config,
    params,
    auth = true,
    ver,
  } = cfg;
  const userOnError = config?.onError;
  const $config = {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    ...(config ?? {}),
    onError: (error: unknown, key: any, cfg: any) => {
      if (error instanceof AxiosError) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          clearToken();
        }
      }
      if (userOnError) {
        userOnError(error, key, cfg);
      }
    }
  };
  // @ts-ignore
  let complexKey: NullableT<FetcherConfigEntityT> = R.isNil(key) ? null : {
    url: key,
    ver,
    params,
  }

  if (auth) {
    if (!Boolean(token) || R.isNil(complexKey)) {
      complexKey = null;
    } else {
      complexKey.token = token;
    }
  }

  // @ts-ignore
  return useSWR<DataT>(complexKey, fetcher, $config);
}
